import styled from 'styled-components';

const EssayWritingBottomBarDiv = styled.div`
  padding: 10px 30px;
  background: #fafafa;
  box-shadow: 0 -2px 3px rgba(0, 0, 0, 0.12);
  align-items: center;
`;
export default EssayWritingBottomBarDiv;
